import { Action } from '@ngrx/store';

export { CreateOrder } from './order';
export { UpdateOrder } from './order';
export { InitPayment, MakePayment } from './payment';
export { CreateAddress, CreateAddressBatch } from './addresses';

export enum CheckoutActionTypes {
  INIT = '[app-checkout/Checkout] Initialize',
}

export class InitCheckout implements Action {
  readonly type = CheckoutActionTypes.INIT;
}

export type CheckoutActions = InitCheckout;
